const SHOWROOM_LAYOUT = 'brand-ads-showroom';

export { SHOWROOM_LAYOUT };
